import { render, staticRenderFns } from "./AccountingArchive.vue?vue&type=template&id=1a22b3cc"
import script from "./AccountingArchive.vue?vue&type=script&lang=js"
export * from "./AccountingArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports